// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__21_fm","box":"WorkspacesBox_box__zx4xI","node":"WorkspacesBox_node__1KkO5"};